<div class="cmdk" (mousedown)="backdrop.press($event)" (click)="onBackdropClick($event)">
  <div
    #dialog
    class="cmdk__dialog"
    role="dialog"
    aria-modal="true"
    aria-label="Command palette"
    (keydown)="onDialogKeydown($event)"
  >
    <div class="cmdk__field">
      <span class="bk-sym cmdk__glass" aria-hidden="true">search</span>
      <input
        #input
        type="text"
        class="cmdk__input"
        role="combobox"
        aria-label="Search pages, actions and message subjects"
        aria-autocomplete="list"
        [attr.aria-expanded]="flat().length > 0"
        [attr.aria-controls]="listId"
        [attr.aria-activedescendant]="activeId()"
        placeholder="Search pages, actions and messages"
        autocomplete="off"
        autocapitalize="off"
        spellcheck="false"
        enterkeyhint="go"
        [value]="query()"
        (input)="onInput($event)"
      />
      <button type="button" class="bk-icon-btn cmdk__close" aria-label="Close command palette" (click)="close()">
        <span class="bk-sym" aria-hidden="true">close</span>
      </button>
    </div>

    <div class="cmdk__list" [id]="listId" role="listbox" aria-label="Results">
      @for (group of groups(); track group.id) {
        <div class="cmdk__group" role="group" [attr.aria-labelledby]="'bk-cmdk-group-' + group.id">
          <div class="cmdk__group-label" [id]="'bk-cmdk-group-' + group.id" aria-hidden="true">{{ group.label }}</div>
          @for (item of group.items; track item.key) {
            <div
              class="cmdk__option"
              role="option"
              [id]="optionId(item.index)"
              [class.is-active]="item.index === activeIndex()"
              [attr.aria-selected]="item.index === activeIndex()"
              (mousemove)="hover(item.index, $event)"
              (mousedown)="$event.preventDefault()"
              (click)="run(item)"
            >
              <span class="bk-sym cmdk__icon" aria-hidden="true">{{ item.icon }}</span>
              @if (item.kind === 'message') {
                <span class="cmdk__text">
                  <span class="cmdk__title">{{ item.title }}</span>
                  @if (item.hint) {
                    <span class="cmdk__sub">{{ item.hint }}</span>
                  }
                </span>
                <app-status class="cmdk__status" [text]="item.statusText || ''" [status]="item.status || ''" />
              } @else {
                <span class="cmdk__text">
                  <span class="cmdk__title">{{ item.title }}</span>
                </span>
                @if (item.hint) {
                  <span class="cmdk__hint">{{ item.hint }}</span>
                }
              }
            </div>
          }
        </div>
      }
    </div>

    @if (statusLine()) {
      <p class="cmdk__note" aria-hidden="true">
        @if (searchState() === 'loading') {
          <span class="cmdk__pulse" aria-hidden="true"></span>
        }
        {{ statusLine() }}
      </p>
    }
    <p class="bk-sr-only" aria-live="polite">{{ announcement() }}</p>

    <div class="cmdk__foot" aria-hidden="true">
      <span class="cmdk__keys"><kbd>↑</kbd><kbd>↓</kbd> to move</span>
      <span class="cmdk__keys"><kbd>Enter</kbd> to open</span>
      <span class="cmdk__keys"><kbd>Esc</kbd> to close</span>
    </div>
  </div>
</div>
